export const fieldBuilder = (fields: string[]): FieldData[] =>
  fields.map((label, i) => ({
    position: i,
    label
  }));

export const updateField = (fields: string[], { position, label }: FieldData) => {
  const newFields = [...fields];
  newFields[position] = label;

  return newFields;
};

export const deleteField = (fields: string[], { position }: FieldData) => fields.filter((_, i) => i !== position);

export const fieldOptionsBuilder = (fields: FieldData[]) =>
  fields.sort(({ position: posA }, { position: posB }) => posA - posB).map(({ label }) => label);
